import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { Switch } from "../../components/ui/switch";
import { Badge } from "../../components/ui/badge";
import { toast } from "sonner";
import { TrendingDown, ShieldAlert, Target, Package } from "lucide-react";
import PageHeader from "../../components/PageHeader/PageHeader";

export function OptimizationsTab() {
  const [optimizations, setOptimizations] = useState([
    {
      id: "low-performers",
      name: "Pause Low-Performing SKUs",
      description:
        "Automatically exclude products in the bottom 25% of sales that receive ad spend but don't convert.",
      icon: TrendingDown,
      enabled: false,
    },
    {
      id: "stop-loss",
      name: "Stop-Loss for Bad SKUs",
      description:
        "Automatically pause ads for SKUs that exceed spend thresholds without generating revenue.",
      icon: ShieldAlert,
      enabled: false,
    },
    {
      id: "smart-segments",
      name: "Smart Product Segments",
      description:
        "Automatically identify and prioritize high-performing products for catalog ads.",
      icon: Target,
      enabled: false,
    },
    {
      id: "inventory-aware",
      name: "Inventory-Aware Ads",
      description:
        "Prevent ads from running for products with low or broken inventory to avoid poor customer experience.",
      icon: Package,
      enabled: false,
    },
  ]);

  const handleToggle = (id) => {
    setOptimizations((prev) =>
      prev.map((opt) => {
        if (opt.id === id) {
          const newEnabled = !opt.enabled;
          toast.success(
            newEnabled ? "Optimization activated" : "Optimization deactivated"
          );
          return { ...opt, enabled: newEnabled };
        }
        return opt;
      })
    );
  };

  return (
    <div className="h-full flex flex-col">
      <PageHeader
        title="Optimizations"
        description="Automatically improve catalog ad performance and reduce wasted spend"
      />
      <div className="p-6 h-full overflow-y-auto flex-1">

      {/* Optimization Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {optimizations.map((optimization) => {
          const Icon = optimization.icon;
          return (
            <Card key={optimization.id} className="shadow-none border-neutral-200">
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div className="flex items-start gap-3">
                    <div className="p-2 bg-neutral-100 rounded-md mt-0.5">
                      <Icon className="size-5 text-neutral-700" />
                    </div>
                    <div className="flex-1">
                      <CardTitle className="text-base">{optimization.name}</CardTitle>
                      <CardDescription className="mt-2 text-neutral-500">
                        {optimization.description}
                      </CardDescription>
                    </div>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <div className="flex items-center justify-between">
                  <Badge 
                    variant={optimization.enabled ? "default" : "secondary"}
                    className={optimization.enabled ? "bg-green-100 text-green-700 hover:bg-green-100" : "bg-neutral-100 text-neutral-500 hover:bg-neutral-100"}
                  >
                    {optimization.enabled ? "Active" : "Inactive"}
                  </Badge>
                  <Switch
                    checked={optimization.enabled}
                    onCheckedChange={() => handleToggle(optimization.id)}
                  />
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
      </div>
    </div>
  );
}
